import create from 'zustand'

export const initialCompaniesData = []
const useCompaniesStore = create((set) => ({
  companies: initialCompaniesData,
  loadingCompanies: true,
  setLoading: (loading) => set(state => ({
    ...state,
    loadingCompanies: loading
  })),
  setCompanies: (companies) => set(
    state => ({ ...state, companies, loadingCompanies: false })
  )
}))

export default useCompaniesStore
